const challengesActions = {
  UPDATE_IDEA_FILTERS: "UPDATE_IDEA_FILTERS",
  SET_IDEA_VIEW_TYPE: "SET_IDEA_VIEW_TYPE",

  updateIdeaFilters(data) {
    return { type: this.UPDATE_IDEA_FILTERS, data }
  },
  setIdeaViewType(ideaViewType) {
    return { type: this.SET_IDEA_VIEW_TYPE, ideaViewType }
  },
}

export default challengesActions
